import yearsConfig from './years.json';

export interface YearsConfig {
  years: string[];
  latestYear: number;
  startYear: number;
  description: string;
}

export const yearsData: YearsConfig = yearsConfig;

// Hjelpefunksjoner for å jobbe med år-data
export const getYears = (): string[] => yearsData.years;
export const getYearsAsNumbers = (): number[] => yearsData.years.map(year => parseInt(year, 10));
export const getLatestYear = (): number => yearsData.latestYear;
export const getStartYear = (): number => yearsData.startYear;
export const getYearRange = (): string => `${yearsData.startYear}-${yearsData.latestYear}`;
export const getYearCount = (): number => yearsData.years.length;
